import { is } from '~/lib/Utils';

export function hasMoreValues({ values }) {
  return !!values
    && is.array(values)
    && values.every(v => is.object(v) && v.hasOwnProperty('name') && v.hasOwnProperty('rasterValue'));
}